"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParagraphElement = void 0;
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var ParagraphElement = exports.ParagraphElement = (0, _cn.withCn)(_plateCommon.PlateElement, 'm-0 px-0 py-1');